<template>
  <div v-if="contractInfo">
    <h6 class="mb-1">Mailvoorkeuren</h6>
    <table>
      <tr>
        <th>Vooraankondiging Incasso</th>
        <td>
          <vs-switch
            v-model="contractInfo.send_collection_notice"
            v-on:change="updateContractSettings"
          >
            <span slot="on">Aan</span>
            <span slot="off">Uit</span>
          </vs-switch>
        </td>
      </tr>
      <tr>
        <th>Maandelijkse factuur</th>
        <td>
          <vs-switch
            v-model="contractInfo.send_periodic_invoice"
            v-on:change="updateContractSettings"
          >
            <span slot="on">Aan</span>
            <span slot="off">Uit</span>
          </vs-switch>
        </td>
      </tr>
      <tr>
        <th>Extra mails</th>
        <td>
          <vs-switch
            v-model="contractInfo.send_un_solicited"
            v-on:change="updateContractSettings"
          >
            <span slot="on">Aan</span>
            <span slot="off">Uit</span>
          </vs-switch>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "../axios";

export default {
  props: ["contract"],
  data() {
    return {
      contractInfo: null
    };
  },
  methods: {
    async retrieveContractSettings() {
      let response = await axios().get(
        `/api/contracts/${this.contract.id}/settings`
      );
      this.contractInfo = response.data;
    },
    async updateContractSettings() {
      let response = await axios().put(
        `/api/contracts/${this.contract.id}/settings`,
        this.contractInfo
      );
      this.contractInfo = response.data;
    }
  },
  async created() {
    if (this.contract.active) {
      await this.retrieveContractSettings();
    }
  }
};
</script>

<style></style>
